// Sementes (exemplos "comece por um destes") + helper de cor do HERO.
// Compartilhado entre a tela de nova conversa (Chat/index.js) e o hero embutido
// na nova automação (Applications/CopilotPanel.js), p/ não duplicar o catálogo.
import SeedCallIcon from "@material-ui/icons/PhoneInTalkOutlined";
import SeedWaIcon from "@material-ui/icons/WhatsApp";
import SeedServerIcon from "@material-ui/icons/DnsOutlined";

// hex (#rrggbb) -> rgba(.., a). Usado p/ o fundo tingido do ícone de cada card.
export const hexA = (hex, a) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ""));
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

export const SEEDS = [
  { icon: SeedCallIcon, color: "#2F6FB0", label: "Atender ligações com uma IA que agenda meus clientes", send: "Quero atender ligações com uma IA que agenda meus clientes." },
  { icon: SeedWaIcon, color: "#1E9E62", label: "Disparar um WhatsApp quando alguém se cadastrar", send: "Quero disparar um WhatsApp quando alguém se cadastrar." },
  { icon: SeedServerIcon, color: "#6A52C4", label: "Me ligar quando um servidor sair do ar", send: "Quero receber uma ligação quando um servidor sair do ar." },
];

export default SEEDS;
